import React from 'react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './page-shell.css'

const OutputZone = () => {
  const variants = [
    { tag: 'Breach-014', note: 'Caption inversion burst', score: '82', link: '/library/volume-4-cringe-mechanics-cringe-as-a-method' },
    { tag: 'Chaos-041', note: 'Hybrid format blend', score: '77', link: '/library/volume-6-genetics-crossover' },
    { tag: 'Remix-220', note: 'Tone shift + hook swap', score: '71', link: '/library/volume-9-engineering-payload-wrappers' },
    { tag: 'Flux-088', note: 'Visual overlay test', score: '68', link: '/library/diagrams-payload-wrapper-model' },
    { tag: 'Echo-512', note: 'Prophetic chain', score: '63', link: '/library/volume-7-fluid-dynamics-branching-coefficient' },
    { tag: 'Core-777', note: 'High novelty fork', score: '86', link: '/library/volume-2-meme-mathematics-fitness-functions' },
  ]

  return (
    <div className="page-shell">
      <Helmet>
        <title>MDMC Output Zone</title>
        <meta property="og:title" content="MDMC Output Zone" />
      </Helmet>
      <Navigation></Navigation>
      <main>
        <section className="page-hero">
          <h1 className="page-hero-title">Output Zone</h1>
          <p className="page-hero-subtitle">
            The live stream of memetic chaos. Fresh variants, lineage hashes,
            and reshare controls surface here for observers.
          </p>
          <div className="page-cta">
            <a className="btn btn-primary btn-lg" href="/collider">
              Run a Collision
            </a>
            <a className="btn btn-secondary btn-lg" href="/collider">
              Public Experiments
            </a>
          </div>
        </section>
        <div className="page-panel">
          <h3>Read-Only Output Feed</h3>
          <p>
            A curated public feed of sample variant families. Each card links to
            the theory behind the mutation instead of pretending a private bus is live.
          </p>
          <div className="row g-3 mt-3">
            {[
              { label: 'Visible Variants', value: variants.length },
              { label: 'Top Score', value: Math.max(...variants.map((v) => Number(v.score))) },
              { label: 'Public Mode', value: 'SFW' },
            ].map((stat) => (
              <div className="col-md-4" key={stat.label}>
                <div className="page-panel" style={{ marginBottom: 0 }}>
                  <h3>{stat.label}</h3>
                  <p className="text-muted">{stat.value}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="row g-3 mt-2">
            {variants.map((item, idx) => (
              <div className="col-md-4" key={item.tag}>
                <div className="page-panel" style={{ marginBottom: 0 }}>
                  <h3>Variant {idx + 1}</h3>
                  <p className="text-muted">Lineage: mdmc-public-{item.tag.toLowerCase()}</p>
                  <p className="text-muted">Collider score: {item.score}/100</p>
                  <p>{item.note}</p>
                  <div className="page-cta">
                    <a className="btn btn-primary btn-sm" href={item.link}>Inspect Theory</a>
                    <a className="btn btn-secondary btn-sm" href="/meme-generator">Make Variant</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="page-panel">
          <h3>Observer Actions</h3>
          <p>
            Output Zone observers can capture variants, follow lineages, and
            subscribe to alerts for high-dank spikes.
          </p>
          <div className="page-cta">
            <a className="btn btn-primary" href="https://tx.wtf" target="_blank" rel="noopener noreferrer">Join tx.wtf</a>
            <a className="btn btn-secondary" href="https://www.janusmedia.net" target="_blank" rel="noopener noreferrer">Applied Research</a>
            <a className="btn btn-secondary" href="https://tx.wtf" target="_blank" rel="noopener noreferrer">Find More Dankness on tx.wtf</a>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  )
}

export default OutputZone

